export type SiteType = 'Unknown' | 'PRV' | 'CP' | 'All';

export interface GeoLocation {
  latitude?: number;
  longitude?: number;
}

export enum SiteFiltersFields {
  isQuiet = 'isQuiet',
  isFlatLine = 'isFlatLine',
  isPressureFault = 'isPressureFault',
  siteType = 'siteType',
  isWithoutLocation = 'showSitesWithoutLocation',
}

export interface SiteFiltersModel {
  [SiteFiltersFields.isQuiet]: boolean;
  [SiteFiltersFields.isFlatLine]: boolean;
  [SiteFiltersFields.isPressureFault]: boolean;
  [SiteFiltersFields.siteType]: SiteType;
  [SiteFiltersFields.isWithoutLocation]: boolean;
}

export interface SiteModel {
  id: number;
  siteName?: string;
  loggerType?: string;
  primaryAddress?: string;
  location?: GeoLocation;
  deviceId?: number;
  smsNumber?: string;
  pmZoneId?: number;
  siteType: SiteType;
  [SiteFiltersFields.isQuiet]?: boolean;
  [SiteFiltersFields.isFlatLine]?: boolean;
  [SiteFiltersFields.isPressureFault]?: boolean;
}

export interface PMZoneSiteModel {
  id: number;
  siteName?: string;
  address?: string;
  loggerType?: string;
  serialNumber?: string;
  smsNumber?: string;
  batteryLevel?: number;
  lastCallIn?: string;
  lastCallInType?: string;
  signalLevel?: number;
  siteType: SiteType;
  [SiteFiltersFields.isQuiet]?: boolean;
  [SiteFiltersFields.isFlatLine]?: boolean;
  [SiteFiltersFields.isPressureFault]?: boolean;
  isAssignedToPmZone?: boolean;
  isAssignedToOtherPmZone?: boolean;
}

export interface SitesMastsModel {
  sites: SiteMast[];
  masts: SiteMast[];
}

export interface Channel {
  id: number;
  name?: string;
  type?: string;
  channelNumber: number;
}

export interface SiteBoundary {
  topLeft?: GeoLocation;
  bottomRight?: GeoLocation;
}

export interface SiteMast {
  location?: GeoLocation;
  sitesCount?: number;
  sites?: SiteModel[];
}
